import { useStaticQuery, graphql } from 'gatsby';

const useHomepageSiteNavigationElementSchemaQuery = () => {
  const query = useStaticQuery(graphql`
    query HomepageSiteNavigationElementSchemaQuery {
      wp {
        sitewideSettings {
          optionsSitewideSettings {
            homepageSiteNavigationElementSchema
          }
        }
      }
    }
  `);

  return query;
};

export default useHomepageSiteNavigationElementSchemaQuery;
